/* Letter-roll hover for Webflow-ported .button elements (shop pages etc.),
   same markup/CSS as the .btn version in main.js. Buttons whose only child is
   a plain text <div> use that div as the label host. */
(function () {
  document.querySelectorAll(".wf .button").forEach((el) => {
    if (el.querySelector(".btn-roll")) return;
    let host = el;
    if (el.children.length === 1 && el.firstElementChild.tagName === "DIV" && !el.firstElementChild.children.length) {
      host = el.firstElementChild;
    } else if (el.children.length) {
      return;
    }
    const label = host.textContent.trim().replace(/\s+/g, " ");
    if (!label) return;

    el.setAttribute("aria-label", label);

    const roll = document.createElement("span");
    roll.className = "btn-roll";
    roll.setAttribute("aria-hidden", "true");

    [...label].forEach((char, i) => {
      const win = document.createElement("span");
      win.className = "btn-roll__char";
      const stack = document.createElement("span");
      stack.className = "btn-roll__stack";
      stack.style.setProperty("--i", String(i));
      for (let copy = 0; copy < 2; copy++) {
        const line = document.createElement("span");
        line.textContent = char;
        stack.appendChild(line);
      }
      win.appendChild(stack);
      roll.appendChild(win);
    });

    host.textContent = "";
    host.appendChild(roll);
  });
})();
